import { bookingStatus } from 'types/booking';

export {
  INFANT_FIRST_NAME_KEY,
  INFANT_LAST_NAME_KEY,
  INFANT_UUID,
  INFANT_DETAIL_KEYS,
  ELIGIBLE_LAP_PASSENGER_TYPES
} from 'constants/passengers';

export const INFANT_EDITABLE_BOOKING_STATUSES = [bookingStatus.CONFIRMED, bookingStatus.TEMPORARILY_ON_HOLD, bookingStatus.ON_HOLD];
